export { default } from './CGMChart';
